import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=1307f3e2"
import script from "./js/document.js?vue&type=script&lang=js&external"
export * from "./js/document.js?vue&type=script&lang=js&external"
import style0 from "./Document.vue?vue&type=style&index=0&id=1307f3e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports